export var selectIsModalOpened = function (state, name) {
    var _a;
    return ((_a = state.modal[name]) === null || _a === void 0 ? void 0 : _a.isVisible) || false;
};
